"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdminSecurity = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../shared/components");
/**
 * WsAiHubAdminSecurity - Security and compliance configuration for AI Hub admin
 *
 * Placeholder component for security settings.
 * This will include authentication, authorization, compliance policies,
 * and data protection settings in future releases.
 *
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubAdminSecurity = function () {
    return (react_1.default.createElement(components_1.PlaceholderTab, { title: "Security", description: "Configure security policies, access controls, and compliance settings.", className: "ws-ai-hub-admin-security" }));
};
exports.WsAiHubAdminSecurity = WsAiHubAdminSecurity;
